import { evaluate } from 'mathjs';
import getControlsFromWorkflow from '../../Shared/jsonSchemaUtilities/getControlsFromWorkflow';
import ControlKind from '../../Shared/controlKind';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import PageState from '../../Shared/pageState';

export default (
  configuredExpression: string,
  workflowPages: PageState[],
  workflowData: Record<string, unknown>
): number => {
  const requiredFieldMustBeProvidedMsg =
    'Required fields must be provided for calculation';
  const calculationErrorMsg = 'Calculation error';

  const variablesInFormula = configuredExpression
    ?.match(/{([^}]+)}/g)
    ?.map((res) => res.replace(/{|}/g, ''));

  const expression = configuredExpression.replace(/{/g, '(').replace(/}/g, ')');

  const numericControls = getControlsFromWorkflow(
    workflowPages,
    ControlKind.NUMERIC
  );

  if (
    !variablesInFormula?.length ||
    !numericControls.length ||
    !Object.getOwnPropertyNames(workflowData).length
  ) {
    return NaN;
  }

  const scope: Record<string, unknown> = {};
  numericControls.forEach((ctrl) => {
    const ctrlProps = ctrl.schema?.properties as JSONSchema7Properties;
    const ctrlId = ctrlProps['id']?.default as string;

    if (variablesInFormula?.includes(ctrlId)) {
      scope[ctrlId] = workflowData[ctrl.id];
    }
  });

  if (Object.getOwnPropertyNames(scope).length !== variablesInFormula.length) {
    throw Error(
      `${requiredFieldMustBeProvidedMsg} (${variablesInFormula.join(',')}).`
    );
  }

  const nullOrUndefinedValues: string[] = [];
  Object.getOwnPropertyNames(scope).forEach((prop) => {
    if (scope[prop] === undefined || scope[prop] === null) {
      nullOrUndefinedValues.push(prop);
    }
  });

  if (nullOrUndefinedValues.length) {
    throw Error(
      `${requiredFieldMustBeProvidedMsg} (${nullOrUndefinedValues.join(',')}).`
    );
  }

  try {
    const evaluation = evaluate(expression, scope);

    if (!isFinite(evaluation) || isNaN(evaluation)) {
      throw Error(calculationErrorMsg);
    }

    return parseFloat(parseFloat(evaluation).toFixed(2));
  } catch (e) {
    throw Error(calculationErrorMsg);
  }
};
